import { getSessionId } from "@/lib/utils/common/common";

const QUIZ_STEP_BASE_URL = process.env.NEXT_PUBLIC_QUIZ_STEP_BASE_URL;

interface QuizStepPayload {
  plan_type: "meta_quiz_assessment";
  question: Record<string, unknown>;
  session_id: string;
  quiz_data: Record<string, (number | string)[]>;
  slug?: string;
}

/**
 * Sends a quiz step event to the backend. Fire-and-forget — errors are
 * logged but never propagated so the quiz UX is never blocked.
 */
export function sendQuizStepEvent(
  question: Record<string, unknown>,
  quizData: Record<string, (number | string)[]>,
  slug?: string,
) {
  const sessionId = getSessionId();
  if (!sessionId || !QUIZ_STEP_BASE_URL) return;

  const payload: QuizStepPayload = {
    plan_type: "meta_quiz_assessment",
    question,
    session_id: sessionId,
    quiz_data: quizData,
    ...(slug ? { slug } : {}),
  };

  fetch(`${QUIZ_STEP_BASE_URL}/quiz/step`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
    keepalive: true,
  }).catch((error) => {
    console.error("Error sending quiz step event", error);
  });
}
